module.exports = __webpack_public_path__ + "img/wh_main_map_text.ce4090ab.png";